module.exports = __webpack_public_path__ + "img/c5fce64.jpg";